import React from 'react';
import Input from '../../../forms/Input';
import ImageUpload from '../../../forms/ImageUpload';
import Checkbox from '../../../forms/Checkbox';

const EventContractInputs = ({ onInput, data, errors }) => (
    <div className="ckp-admin-forms-body">
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column ckp-admin-grid-column--border-right">
                <span className="ckp-ts-h3 u-bold u-margin-bottom-1">Event Contract Types</span>
                <div className="ckp-admin-grid-row">
                    <Checkbox
                        className="ckp-checkbox-mui u-margin-bottom-1"
                        name="allowClearanceContracts"
                        checked
                        disabled
                        label={'Clearance Contracts'}
                    />
                </div>
                <div className="ckp-admin-grid-row">
                    <Checkbox
                        name="allowPerformanceContracts"
                        checked={data.allowPerformanceContracts}
                        label={'Performance Contracts'}
                        onChange={e => onInput(e.target.checked, e.target.name)}
                    />
                </div>
            </div>
            <div className="ckp-admin-grid-row is-wrap">
                <div className="ckp-admin-grid-row is-100pct u-margin-bottom-3">
                    <div className="ckp-admin-grid-column">
                        <ImageUpload
                            value={data.defaultSignature}
                            className="is-rectangle"
                            name="defaultSignature"
                            onChange={onInput}
                            label={'Clearance signature (250px x 150px)'}
                            keepLabel={true}
                        />
                    </div>
                    <div className="ckp-admin-grid-column u-vertical-center">
                        <Input
                            className="is-without-padding"
                            errorMessage={errors.defaultSigner}
                            label="Clearance Signer"
                            name="defaultSigner"
                            onChange={onInput}
                            value={data.defaultSigner}
                        />
                    </div>
                    <div className="ckp-admin-grid-column u-vertical-center">
                        <Input
                            className="is-without-padding"
                            errorMessage={errors.defaultSignerFunction}
                            label="Clearance Signer Function"
                            name="defaultSignerFunction"
                            onChange={onInput}
                            value={data.defaultSignerFunction}
                        />
                    </div>
                </div>
                {data.allowPerformanceContracts ? (
                    <div className="ckp-admin-grid-row is-100pct">
                        <div className="ckp-admin-grid-column">
                            <ImageUpload
                                value={data.performanceSignature}
                                className="is-rectangle"
                                name="performanceSignature"
                                onChange={onInput}
                                label={'Performance signature (250px x 150px)'}
                                keepLabel={true}
                            />
                        </div>
                        <div className="ckp-admin-grid-column u-vertical-center">
                            <Input
                                className="is-without-padding"
                                errorMessage={errors.performanceSigner}
                                label="Performance Signer"
                                name="performanceSigner"
                                onChange={onInput}
                                value={data.performanceSigner}
                            />
                        </div>
                        <div className="ckp-admin-grid-column u-vertical-center">
                            <Input
                                className="is-without-padding"
                                errorMessage={errors.performanceSignerFunction}
                                label="Performance Signer Function"
                                name="performanceSignerFunction"
                                onChange={onInput}
                                value={data.performanceSignerFunction}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    </div>
);

export default EventContractInputs;



// WEBPACK FOOTER //
// ./src/components/admin/forms/events/EventContractInputs.js